import { useState, useRef, useEffect } from 'react'
import { useMeeting } from '../../contexts/MeetingContext'

export default function BoasVindas() {
  const { meeting, mode, startFromWelcome, cancelMeeting } = useMeeting()
  const [msg, setMsg]       = useState<string>('')
  const [editing, setEditing] = useState<boolean>(false)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  // Pré-preenche com o nome do projeto ao abrir
  useEffect(() => {
    if (mode === 'welcome' && meeting) {
      setMsg(m => m || `Bem-vindo`)
    }
  }, [mode, meeting])

  useEffect(() => {
    if (editing) textareaRef.current?.focus()
  }, [editing])

  // Esc fecha a tela de boas-vindas
  useEffect(() => {
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') cancelMeeting() }
    if (mode === 'welcome') window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [mode, cancelMeeting])

  if (mode !== 'welcome' || !meeting) return null

  return (
    <div className="fixed inset-0 z-[300] flex flex-col items-center justify-center select-none"
      style={{ background: '#000' }}>

      {/* Linha decorativa superior */}
      <div className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)' }} />

      {/* Mensagem principal */}
      <div className="group flex flex-col items-center w-full px-16 text-center">

        {editing ? (
          <textarea
            ref={textareaRef}
            value={msg}
            onChange={e => setMsg(e.target.value)}
            onBlur={() => setEditing(false)}
            onKeyDown={e => { if (e.key === 'Escape') setEditing(false) }}
            rows={3}
            className="resize-none bg-transparent border-none outline-none text-center w-full text-white"
            style={{
              fontSize: 'clamp(40px, 7vw, 96px)',
              fontWeight: 200,
              letterSpacing: '-0.025em',
              lineHeight: 1.05,
              caretColor: 'rgba(255,255,255,0.5)',
            }}
          />
        ) : (
          <h1
            onClick={() => setEditing(true)}
            className="cursor-text text-white"
            style={{
              fontSize: 'clamp(40px, 7vw, 96px)',
              fontWeight: 200,
              letterSpacing: '-0.025em',
              lineHeight: 1.05,
              maxWidth: '100%',
            }}
          >
            {msg || (
              <span style={{ opacity: 0.15 }}>Clique para escrever…</span>
            )}
          </h1>
        )}

      </div>

      {/* Separador */}
      <div className="w-8 my-16" style={{ height: 1, background: 'rgba(255,255,255,0.10)' }} />

      {/* Nome da reunião */}
      <p className="text-[12px] tracking-[0.20em] uppercase mb-16"
        style={{ color: 'rgba(255,255,255,0.20)' }}>
        {meeting.reuniao.titulo}
      </p>

      {/* Botão discreto */}
      <button
        onClick={startFromWelcome}
        className="px-6 py-2.5 rounded-full border text-[11px] tracking-[0.12em] uppercase cursor-pointer transition-all duration-300"
        style={{
          border: '1px solid rgba(255,255,255,0.12)',
          background: 'transparent',
          color: 'rgba(255,255,255,0.35)',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.color = 'rgba(255,255,255,0.75)'
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.30)'
          e.currentTarget.style.background = 'rgba(255,255,255,0.04)'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.color = 'rgba(255,255,255,0.35)'
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'
          e.currentTarget.style.background = 'transparent'
        }}
      >
        Iniciar reunião
      </button>

      {/* Linha decorativa inferior */}
      <div className="absolute bottom-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)' }} />
    </div>
  )
}
